import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { ZodObject } from 'zod';
import { formMessages } from '../../messages';
import type { FormValues, InputID } from '../types';

/**
 * Gather the basic props (that only depend on the id) for each input
 */
export const getFieldProps =
  (
    register: UseFormRegister<FormValues>,
    errors: FieldErrors<FormValues>,
    formatMessage: Function,
    schema: ZodObject<any>,
  ) =>
  (inputId: InputID | 'approval', uniqueId: string) => {
    const fieldSchema = schema.shape[inputId];
    const isOptional =
      typeof fieldSchema.isOptional === 'function'
        ? fieldSchema.isOptional()
        : fieldSchema.isOptional;
    return {
      ...register(inputId),
      id: `${inputId}-${uniqueId}`,
      helperText: errors[inputId]?.message,
      label:
        formMessages[inputId]?.label &&
        `${formatMessage(formMessages[inputId].label)}${!isOptional ? ' *' : ''}`,
      error: !!errors[inputId],
      placeholder:
        inputId in formMessages &&
        formMessages[inputId]?.placeholder &&
        formMessages[inputId]?.placeholder.defaultMessage !== ''
          ? formatMessage(formMessages[inputId].placeholder)
          : undefined,
      required: !isOptional,
    };
  };
